import { Consultorios, type Profesional } from './api';
import { session } from './auth.svelte';

function normalize(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

function tokens(text: string): string[] {
  return normalize(text).split(/\s+/).filter(t => t.length > 2);
}

function scoreMatch(usuario: string, prof: Profesional): number {
  const u = normalize(usuario.split('@')[0]);
  const nombre = normalize(prof.nombre);
  if (!u || !nombre) return 0;
  if (nombre.includes(u) || u.includes(nombre)) return 100;
  const uTokens = tokens(usuario);
  const nTokens = tokens(prof.nombre);
  let hits = 0;
  for (const t of uTokens) {
    if (nTokens.some(n => n.includes(t) || t.includes(n))) hits++;
  }
  if (prof.colegiado && u.includes(normalize(prof.colegiado))) hits += 2;
  return hits;
}

const MEDICO_ROLES = new Set([
  'medico', 'vet-medico', 'optica-optometrista', 'consultorio-externo',
]);

export function sessionEsMedico(): boolean {
  const roles = session.value?.roles ?? [];
  return roles.some(r => MEDICO_ROLES.has(r));
}

/** Resuelve el profesional del tenant que corresponde al usuario en sesión. */
export async function resolveMedicoProfesional(): Promise<Profesional | null> {
  const profs = await Consultorios.profesionales(true).catch(() => [] as Profesional[]);
  if (!profs.length) return null;

  const usuario = session.value?.usuario?.trim() ?? '';
  if (usuario) {
    let best: Profesional | null = null;
    let bestScore = 0;
    for (const p of profs) {
      const s = scoreMatch(usuario, p);
      if (s > bestScore) {
        bestScore = s;
        best = p;
      }
    }
    if (best && bestScore >= 2) return best;
  }

  const roles = session.value?.roles ?? [];
  if (sessionEsMedico() || roles.includes('admin-tenant') || roles.includes('admin-platform')) {
    return profs[0];
  }
  return null;
}

export async function resolveMedicoId(): Promise<string | undefined> {
  return (await resolveMedicoProfesional())?.id;
}
